import { requestApi } from './Api';

export const getACHs = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/patient/ach/get',
    params
  });

export const deleteACH = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/patient/ach/remove',
    params
  });

export const updateACH = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/patient/ach/update',
    params
  });
